import { inject, Pipe, PipeTransform } from '@angular/core';
import { ApiAnnotation } from '@mhe/reader/models';
import { MaterialAnnotationType } from '../material-annotation-list.model';
import { format } from 'date-fns';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'ariaAnnotation',
  standalone: true,
  pure: true,
})
export class AriaAnnotationPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);
  transform(annotation: ApiAnnotation, materialType: MaterialAnnotationType): string {
    // Generate the formatted date if the annotation has an updatedAt field
    const annotationDate = annotation.updatedAt
      ? format(new Date(annotation.updatedAt), 'MM/DD/YY') + ' '
      : '';
    // Only compute color/shape for highlights; avoid translation work for other types
    const annotationColor = materialType === MaterialAnnotationType.HIGHLIGHTS && annotation.color
      ? this.translateService.instant('annotation.color-' + annotation.color.split('-')[0])
      : '';
    const annotationShape = materialType === MaterialAnnotationType.HIGHLIGHTS && annotation.shape
      ? this.translateService.instant('annotation.' + annotation.shape)
      : '';
    // Determine the text based on the annotation type
    const annotationText = materialType === MaterialAnnotationType.NOTES
      ? (annotation.note ?? '')
      : (annotation.text ?? '');

    // Constructing the aria label based on the annotation type
    if (materialType === MaterialAnnotationType.HIGHLIGHTS) {
      return `${annotationDate} ${annotationColor} ${annotationShape} ${annotationText}`;
    }
    return `${annotationDate} ${annotationText}`;
  }
}
